module.exports = __webpack_public_path__ + "img/20190713125017424.4d07a8e3.png";